// Ключи кеша списка проектов и промптов проекта: нужны и самому списку (projects-page),
// и удалению проекта из настроек — оно вычищает удалённый проект из этого кеша.
export const projectsQueryKey = ['projects'] as const
// Архивная вкладка (?archived=only) и карта имён биллинга (?archived=with) — отдельные от
// активного списка запросы под тем же GET /projects. Префикс совпадает с projectsQueryKey,
// поэтому invalidateQueries({ queryKey: projectsQueryKey }) инвалидирует все три сразу —
// react-query по умолчанию сравнивает ключи как префикс, а не точное совпадение.
export const archivedProjectsQueryKey = ['projects', 'archived'] as const
export const projectsWithArchivedQueryKey = ['projects', 'with-archived'] as const
export const projectPromptsQueryKey = (projectId: string) => ['prompts', projectId] as const

// Справочник тегов организации: общий для полосы фильтров и редактора на карточке.
export const projectTagsQueryKey = ['project-tags'] as const
